
<template>
  <div class="record_box">
    <div class="br_box">
      <img class="banner"
           :src="detailJson.imgBig" />
    </div>
    <div class="bag_title">
      <p class="name">{{detailJson.customizeName}}</p>
      <p class="money">￥{{detailJson.price}} <span class="readPeople right">{{detailJson.receiveCount}}人已领取</span></p>
    </div>
    <div class="serves">
      <p class="title">服务项目</p>
      <img class="bg"
           :src="detailJson.servicePic"
           alt="">
    </div>
    <div class="info">
      <p class="title">使用说明</p>
      <ul>
        <li v-for="(item,index) in list"
            :key="index">
          {{item}}
        </li>
      </ul>
    </div>
    <div class="btn_box">
      <span class="btn"
            @click="toShow">查看券码</span>
    </div>
    <div class="shadow"
         v-show="showToast"></div>
    <div class="toast"
         v-show="showToast">
      <span class="close"
            @click="toHide"></span>
      <img class="logo"
           src="../../assets/img/vip/card/toast_logo.png">
      <p class="ts_title">{{detailJson.name}}体验券码</p>
      <p class="ts_code">{{copyText}}</p>
      <span class="btn btn_copy"
            :class="{'btn_alCopy':isCopy}"
            v-clipboard:copy="copyText"
            v-clipboard:success="onCopy"
            v-clipboard:error="onError">{{btnText}}</span>
      <span class="btn"
            @click="toPage">前往使用</span>
    </div>
  </div>
</template>

<script>
export default {
  components: {
  },
  data () {
    return {
      copyText: '850QLmC0',
      btnText: '复制券码',
      isCopy: false,
      money: '',
      id: '',
      goldId: '',
      balanceList: [],
      showToast: false,
      detailJson: {},
      list: []
    }
  },
  mounted () {
    this.util.title('券详情');
    this.id = this.$route.query.id
    this.goldId = this.$route.query.goldId
    let _this = this;
    _this.getDetail();

  },
  methods: {
    toPage () {
      window.location.href = this.detailJson.url;
    },
    //, 复制成功
    onCopy (e) {
      this.isCopy = true;
      this.btnText = '券码已复制！'
    },
    // 复制失败
    onError (e) {
      this.util.toast({ msg: '复制失败' })
    },
    toShow () {
      this.lookPass();
    },
    toHide () {
      this.showToast = false;
    },
    lookPass () {
      let _this = this;
      this.$post('/app/valueAdded/getCommodityPass/' + _this.goldId, {})
        .then(res => {
          var e = res;
          if (e.code == 200) {
            this.copyText = e.data.password;
            this.showToast = true;
          }
          else {
            _this.util.toast({ msg: e.message })
          }
        })
        .catch(error => { });
    },
    getDetail () {
      let _this = this;
      this.$get('/app/valueAdded/commodities/' + this.id, {})
        .then(res => {
          var e = res;
          if (e.code == 200) {
            _this.detailJson = e.data;
            _this.list = e.data.tutorial.split('；')
            console.log(_this.list)
          }
          else {
            _this.util.toast({ msg: e.message })
          }
        })
        .catch(error => { });
    }
  }

}
</script>
<style scoped>
.record_box {
  background: #f7f7f7;
  width: 100%;
  /* height: 100%; */
  padding-bottom: 1.5rem;
}
.br_box {
  padding: 0.15rem;
  padding-bottom: 0;
  height: 1.26rem;
}
.banner {
  display: inline-block;
  /* background: url("../../assets/img/vip/card/bag_bg.png") no-repeat center
    center;
  background-size: 100% 100%; */
  height: 1.11rem;
  width: 100%;
}
.bag_title {
  background: #fff;
  padding: 0.18rem 0.15rem;
  padding-bottom: 0.1rem;
  margin-bottom: 0.1rem;
}
.bag_title .name {
  font-size: 0.17rem;
  color: #333;
  font-family: PingFangSC;
  font-weight: 500;
}
.bag_title .money {
  color: #ff514a;
  font-size: 0.27rem;
  font-family: PingFangSC;
  font-weight: 500;
  position: relative;
}
.bag_title .readPeople {
  font-size: 0.12rem;
  color: #999;
  position: absolute;
  bottom: 0.05rem;
  right: 0;
}
.info,
.serves {
  padding: 0.15rem;
  background: #ffffff;
  font-size: 0.12rem;
  color: #333;
}
.serves {
  margin-bottom: 0.1rem;
}
.title {
  color: #333;
  font-size: 0.14rem;
  margin-bottom: 0.1rem;
  font-family: PingFangSC;
  font-weight: 700;
}
.info ul li {
  line-height: 0.3rem;
}
.logo1,
.logo2,
.logo3,
.logo4,
.logo5 {
  display: inline-block;
  background: url("../../assets/img/vip/card/bag_icon1.png") no-repeat center
    center;
  background-size: 100% 100%;
  width: 0.24rem;
  height: 0.24rem;
  margin-right: 0.17rem;
  top: 0.07rem;
  position: relative;
}
.logo2 {
  background: url("../../assets/img/vip/card/bag_icon2.png") no-repeat center
    center;
  background-size: 100% 100%;
}
.logo3 {
  background: url("../../assets/img/vip/card/bag_icon3.png") no-repeat center
    center;
  background-size: 100% 100%;
}
.logo4 {
  background: url("../../assets/img/vip/card/bag_icon4.png") no-repeat center
    center;
  background-size: 100% 100%;
}
.logo5 {
  background: url("../../assets/img/vip/card/bag_icon5.png") no-repeat center
    center;
  background-size: 100% 100%;
}
.btn_box {
  text-align: center;
  /* background: #f7f7f7; */
  position: fixed;
  width: 100%;
  bottom: 0.3rem;
}
.btn {
  display: inline-block;
  width: 85%;
  margin: 0 auto;
  color: #fff;
  height: 0.5rem;
  text-align: center;
  background: linear-gradient(
    132deg,
    rgba(89, 163, 252, 1) 0%,
    rgba(60, 100, 246, 1) 100%
  );
  border-radius: 25px;
  line-height: 0.5rem;
  font-size: 0.17rem;
}
.serves .bg {
  /* width: 100%; */
  height: 0.52rem;
}
.shadow {
  position: fixed;
  width: 100%;
  height: 100%;
  background: #000;
  opacity: 0.4;
  z-index: 11;
  top: 0;
  left: 0;
}
.toast {
  width: 75%;
  margin: 0 auto;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 111;
  background: #fff;
  text-align: center;
  border-radius: 10px;
  padding-top: 0.44rem;
  padding-bottom: 0.3rem;
}
.toast .logo {
  width: 0.99rem;
  height: 0.85rem;
}
.toast .ts_title {
  color: #000;
  font-size: 0.16rem;
  margin-bottom: 0.18rem;
}
.toast .ts_code {
  color: #333;
  font-size: 0.26rem;
  font-family: PingFang;
  font-weight: 500;
  margin-bottom: 0.17rem;
}
.btn_copy,
.btn_alCopy {
  background: #ffffff;
  border: 1px solid rgba(79, 140, 250, 1);
  color: #4f8cfa;
  margin-bottom: 0.1rem;
}
.btn_alCopy {
  border: 1px solid rgba(238, 238, 238, 1);
  color: #c2c2c2;
}
.toast .close {
  background: url("../../assets/img/vip/card/toast_close.png") no-repeat center
    center;
  background-size: 100% 100%;
  display: inline-block;
  width: 0.16rem;
  height: 0.16rem;
  position: absolute;
  right: 0.2rem;
  top: 0.2rem;
}
</style>
